<template>
    <div class="module-pin-change pin-change">
        <div class="pin-change__block">
            <label for="newPin" class="pin-change__label">Nowy PIN:</label>
            <div class="pin-change__pin">
                <input v-model="newPin" maxlength="4" id="newPin" :type="showPin ? 'text' : 'password'" class="pin-change__input" :class="{'error': newPinError}" @keypress="isNumber"/>
                <IconEye class="pin-change__icon" @mousedown="showPin = !showPin" @mouseup="showPin = !showPin"></IconEye>
            </div>
        </div>

        <div class="pin-change__block">
            <label for="newPinRepeat" class="pin-change__label">Powtórz nowy PIN:</label>
            <div class="pin-change__pin">
                <input v-model="newPinRepeat" maxlength="4" id="newPinRepeat" :type="showPinRepeat ? 'text' : 'password'" class="pin-change__input" :class="{'error': newPinRepeatError}" @keypress="isNumber"/>
                <IconEye class="pin-change__icon" @mousedown="showPinRepeat = !showPinRepeat" @mouseup="showPinRepeat = !showPinRepeat"></IconEye>
            </div>
        </div>

        <div class="errors" v-if="pinError">
            <span>{{ pinError }}</span>
        </div>

        <div class="pin-change__btns">
            <button class="pin-change__btn pin-change__btn--reject btn-cancel" @click="reject"><span>Anuluj</span></button>
            <button to="/strefa-rodzica" class="pin-change__btn pin-change__btn--save btn-success"  @click="saveNewPin"><span>Zapisz zmiany</span></button>
        </div>        
    </div>
</template>

<script>
import axios from "axios";
import IconEye from "../elements/icons/IconEye.vue";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
    name: "ModulePinChange",
    components: {
        IconEye
    },
    props: {
        subProfileId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            UPDATE_SUBPROFILE_PIN: ' /api/krainaabc/subprofile/pin?device=www',
            UPDATE_PIN: '/api/account/user-application-data/pin?device=www',
            newPin: '',
            newPinRepeat: '',
            showPin: false,
            showPinRepeat: false,
            newPinError: '',
            newPinRepeatError: '',
            pinError: '',     
        };
    }, 
    methods: {
        isNumber(e) {
            if ((!/[1-9]/.test(e.key) && e.key !== 'Backspace') || (e.target.value.length === 4 && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        },
        validatePin() {
            if(this.newPin.length < 4 || this.newPinRepeat.length < 4) {
                this.pinError = 'PIN musi się składać z 4 cyfr'

                if(this.newPin.length < 4) {
                    this.newPinError = true;
                } else {
                    this.newPinError = false;
                }

                if(this.newPinRepeat.length < 4) {
                    this.newPinRepeatError = true;
                } else {
                    this.newPinRepeatError = false;
                }

                return false;
            }

            if(this.newPin !== this.newPinRepeat) {
                this.pinError = 'Wartości obu pól muszą być takie same';
                this.newPinRepeatError = true;
                return false;
            }

            this.pinError = '';
            this.newPinError = false;
            this.newPinRepeatError = false;
            return true;
        },
        saveNewPin() {
            if(this.validatePin()) {
                const data = {};

                if(this.subProfileId !== '') { // jeśli zmiana pinu dla subprofilu
                    data['subProfile_id'] = this.subProfileId;
                } else { // jeśli zmiana pinu rodzica
                    data['src'] = 'krainaabc';
                }

                let endpoint = this.subProfileId ? this.UPDATE_SUBPROFILE_PIN : this.UPDATE_PIN;

                data['pin'] = parseInt(this.newPin);
                data['pin_repeat'] = parseInt(this.newPinRepeat);

                axios
                    .post(endpoint, data)
                    .then((response) => {
                        if(response && response.data && response.data.error) {
                            toast.error("Nie udało sie zmienić PINu");
                        } else {
                            toast.success("Zmieniono PIN");
                            this.$emit("closeModule", { success: true, pin: this.newPin });
                        }
                    })
                    .catch(() => {
                        this.$emit("closeModule", { success: false });
                        toast.error("Nie udało sie zmienić PINu");
                    })
                }
        },
        reject() {
            this.$emit("closeModule", false);
        }          
    },
    mounted() {
        document.getElementById('newPin').focus();
    }
};
</script>